<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span @click="goBack">家长情况测评 ></span>
			<span>开始测试</span>
		</div>
		<section class="gaokao-content">
			<div class="my-title">家长情况测评</div>
			<article class="testTwo-con">
				<div class="testTwo-list" v-for="(item, index) in list" :key="index">
					<p class="test-ctxt">{{ item.topic }}</p>
					<ul class="testTwo-ul">
						<li v-for="(t, index) in item.option" :key="index">
							<input type="radio" name="sel" />
							<p>{{ t.txt }}</p>
						</li>
					</ul>
				</div>
			</article>
			<div class="test-btn"><button class="gaokao-btn" @click="subPop()">提交</button></div>
		</section>

		<!-- 提交弹窗 -->
		<div class="popup" v-show="isSub">
			<div class="pop-width animated fadeIn">
				<div class="submit-bg"><img src="../../../image/pop-del.png" @click="subDel" /></div>
				<p class="submit-tit">提交成功</p>
				<p class="submit-txt">系统将自动跳转[我的报告]，跳转后点击[查看报告]</p>
				<p class="submit-txt">马上了解最适合你科目组合吧!</p>
				<button class="gaokao-btn pop-btn" @click="goReport">确定</button>
			</div>
		</div>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-if="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isJiaIng: false,
				// 弹窗
				isSub: false,
				list: [{
						topic: '1/44不管我的工作或生活再忙碌，每天我都会留-些时间给孩子',
						option: [{
								txt: '很符合自己的情况'
							},
							{
								txt: '比较符合自己的情况'
							},
							{
								txt: '一般般'
							},
							{
								txt: '较不符合自己的情况'
							},
							{
								txt: '很不符合自己的情况'
							}
						]
					},
					{
						topic: '2.喜欢阅读历史题材相关的书籍',
						option: [{
								txt: '很符合自己的情况'
							},
							{
								txt: '比较符合自己的情况'
							},
							{
								txt: '一般般'
							},
							{
								txt: '较不符合自己的情况'
							},
							{
								txt: '很不符合自己的情况'
							}
						]
					},
					{
						topic: '3.经常关注经济与政治的关系，阅读相关的时评或文章。',
						option: [{
								txt: '很符合自己的情况'
							},
							{
								txt: '比较符合自己的情况'
							},
							{
								txt: '一般般'
							},
							{
								txt: '较不符合自己的情况'
							},
							{
								txt: '很不符合自己的情况'
							}
						]
					},
					{
						topic: '4.喜欢解决复杂的化学问题，有机会的话想要参加化学知识竞赛',
						option: [{
								txt: '很符合自己的情况'
							},
							{
								txt: '比较符合自己的情况'
							},
							{
								txt: '一般般'
							},
							{
								txt: '较不符合自己的情况'
							},
							{
								txt: '很不符合自己的情况'
							}
						]
					}
				],
				sel: ''
			};
		},
		mounted() {
			this.drawLineB();
		},
		methods: {
			drawLineB() {
				const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
				myChart.setOption({
					color: ['#feb9a7', '#3171ff00'],
					tooltip: {
						trigger: 'item',
						show: false
					},
					graphic: {
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: '75%',
							textAlign: 'center',
							fill: '#7ac8fd',
							fontSize: 24
						}
					},
					legend: {
						top: '0%',
						left: 'center'
					},
					series: [{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						hoverAnimation: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [{
							value: 1048,
							name: ''
						}, {
							value: 735,
							name: ''
						}]
					}]
				});
			},
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},
			// 返回上一级
			goBack() {
				this.$router.go(-1);
			},
			// 弹窗
			subPop() {
				var that = this;
				that.isSub = true;
				setTimeout(function() {
					that.goReport();
				}, 5000);
			},
			subDel() {
				var that = this;
				that.isSub = false;
			},
			goReport() {
				this.$router.push('/service');
			}
		}
	};
</script>

<style scoped>
	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	.test-tit {
		font-size: 16px;
		color: #333;
		position: relative;
		padding-left: 20px;
		margin-bottom: 30px;
	}

	.test-tit::after {
		position: absolute;
		content: '';
		width: 0;
		height: 20px;
		left: 0;
		top: 50%;
		margin-top: -10px;
		border: 2px solid #333;
		border-radius: 50px;
	}

	/* testTwo-con */
	.testTwo-con {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.testTwo-list {
		width: 100%;
		height: auto;
		overflow: hidden;
		margin-top: 40px;
	}

	.test-ctxt {
		font-size: 15px;
		color: #333;
		margin-bottom: 25px;
	}

	.testTwo-ul {
		padding: 0 30px;
		height: auto;
		overflow: hidden;
	}

	.testTwo-ul li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 25px;
	}

	.testTwo-ul li:last-child {
		margin-bottom: 0;
	}

	.testTwo-ul li input {
		margin-right: 15px;
	}

	.testTwo-ul li p {
		font-size: 15px;
		color: #333;
	}

	.test-btn {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.test-btn button {
		margin-left: 20px;
		margin-right: 20px;
	}
</style>
